/**
 * WebView 處理：初始化與導向系統瀏覽器
 */

import { isInWebView, showWebViewWarning, hideGoogleLoginButtons } from './webViewDetector';
import { isTWAEnvironment } from './platformDetection';

export function initWebViewHandler() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('reset_webview_warning')) {
    localStorage.removeItem('webview_warning_dismissed');
    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
  }

  if (!isInWebView()) return;
  if (isTWAEnvironment()) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleWebViewEnvironment);
  } else {
    handleWebViewEnvironment();
  }
}

function handleWebViewEnvironment() {
  if (isTWAEnvironment()) return;
  showWebViewWarning();
  hideGoogleLoginButtons();
}

export default initWebViewHandler;
